<style scoped lang="sass">
.mask_floor
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  display: flex
  flex-direction: column
  align-items: center
  background-color: rgba(0, 0, 0, .77)
  color: #fff
  z-index: 2

  .title
    font-size: 21px
    line-height: 21px

  .description
    margin-top: 10px
    padding: 0 50px
    font-size: 15px
    line-height: 17px
    text-align: center

  .got_it
    margin-top: 20px
    height: 38px
    border: none
    border-radius: 4px
    background-color: var(--menu-primary-background-colour)
    font-size: 15px
    text-align: center
    color: #fff
    border-radius: 5px !important

  .icon_border
    display: flex
    align-items: center
    justify-content: center
    width: 60px
    height: 60px
    border: 1px solid #fff
    border-radius: 100%

    .icon_bgc
      display: flex
      align-items: center
      justify-content: center
      width: 45px
      height: 45px
      border-radius: 100%
      background-color: var(--menu-header-background-colour)
</style>
<style lang="sass" scoped>

.top
  align-self: flex-start
  height: 110PX
  margin-top: 218PX
  margin-bottom: 35PX

.title
  margin-top: -10px

.img
  height: 100%

</style>

<template lang="pug">
.mask_floor(v-if="showMask")
  .top(:style="topStyle")
    img.img(:src="leftArrowSrc")
  span.title Know what you're after?
  p.description Tap here to quickly jump to your favourite category.
  van-button.got_it.ls3(@click="clickButton") GOT IT
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    showMask: {
      type: Boolean,
      default: true
    },
    bindQuerySelectorString: { type: String, default: '' }
  },
  mounted() {
    this.initTop()
  },
  watch: {
    showMask: {
      immediate: true,
      handler(val) {
        this.initTop()
      }
    },
  },
})
class MaskCategoryListButton extends Vue {
  topStyle = ''
  leftArrowSrc = require('@/assets/venue-home-mask/left-arrow.png')
  clickButton() {
    this.$emit('update:showMask', false)
    localStorage.setItem('showMaskCategoryListButton', JSON.stringify({ value: 'unShow', date: new Date().toISOString().split('T')[0] }))
  }

  initTop() {
    if (this.bindQuerySelectorString.length > 0) {
      const container = document.getElementById(this.bindQuerySelectorString)
      if (container) {
        this.topStyle = 'margin-top: ' + container.getBoundingClientRect().top + 'PX'
      }
    }
  }
}

export default MaskCategoryListButton
</script>
